import React, {FormEventHandler} from 'react';
import styled from 'styled-components';
import {FieldSet} from '../Forms/FieldSet';

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLFieldSetElement>,
    HTMLFieldSetElement
  > {
  label?: string;
  onValueChange?: (value: string) => void;
  onChange?: FormEventHandler<HTMLFieldSetElement>;
}

export const RadioGroup = ({
  onValueChange,
  onChange,
  children,
  className,
  ref,
  ...props
}: Props & {ref?: React.Ref<HTMLFieldSetElement>}) => {
  return (
    <FieldSet
      {...props}
      ref={ref}
      className={className}
      onChange={e => {
        onValueChange?.((e.target as unknown as HTMLInputElement).value);
        onChange?.(e);
      }}
    >
      <OptionsWrapper className={className}>{children}</OptionsWrapper>
    </FieldSet>
  );
};

const OptionsWrapper = styled.div`
  display: flex;

  > label {
    min-width: 90px;
    &:not(:last-child) {
      margin-right: 20px;
    }
  }
`;
